import LocationAutocomplete from '../LocationAutocomplete';
import { t } from '../../utils/i18n';

export default function HeroSearch({
  searchMode,
  onSearchModeChange,
  searchQuery,
  onSearchQueryChange,
  onLocationSelect,
  onSearch,
  locationAutocompleteRef,
}) {
  return (
    <div className="w-full animate-fade-in" style={{ animationDelay: '0.2s' }}>
      <form onSubmit={onSearch} className="relative">
        <div className="flex items-start sm:items-center mb-3">
          <div className="landing-segmented inline-flex items-center rounded-full p-0.5">
            <button
              type="button"
              onClick={() => onSearchModeChange('parent')}
              className={`landing-segmented-btn px-3 sm:px-4 py-1.5 text-xs sm:text-sm font-medium rounded-full transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40 ${
                searchMode === 'parent' ? 'landing-segmented-btn--active' : ''
              }`}
            >
              {t('landing.search.findSitter')}
            </button>
            <button
              type="button"
              onClick={() => onSearchModeChange('sitter')}
              className={`landing-segmented-btn px-3 sm:px-4 py-1.5 text-xs sm:text-sm font-medium rounded-full transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40 ${
                searchMode === 'sitter' ? 'landing-segmented-btn--active' : ''
              }`}
            >
              {t('landing.search.findJob')}
            </button>
          </div>
        </div>

        <div className="relative z-10">
          <div className="landing-search-bar flex flex-col sm:flex-row gap-2 sm:gap-0 sm:items-stretch">
            <div className="flex-1 relative flex items-center min-w-0">
              <LocationAutocomplete
                ref={locationAutocompleteRef}
                value={searchQuery}
                onChange={onSearchQueryChange}
                onSelect={onLocationSelect}
                placeholder={t('landing.search.placeholder')}
                className="w-full landing-search-input"
                debounceMs={300}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    locationAutocompleteRef.current?.closeDropdown();
                    onSearch(e);
                  }
                }}
              />
            </div>
            <button
              type="submit"
              onClick={() => locationAutocompleteRef.current?.closeDropdown()}
              className="landing-search-submit btn-primary w-full sm:w-auto px-6 sm:px-8 py-3.5 sm:py-0 text-sm sm:text-base font-semibold whitespace-nowrap flex-shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/50 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-[var(--color-bg)]"
            >
              {searchMode === 'parent'
                ? t('landing.search.submitSitter')
                : t('landing.search.submitJob')}
            </button>
          </div>
        </div>
      </form>

      <p className="mt-4 text-xs sm:text-sm text-[var(--color-text-muted)]">
        {t('landing.trust.micro')}
      </p>
    </div>
  );
}
